export default __webpack_public_path__ + "static/assets/8144930ffa954b8af76166007268d67f.png";